import { createApp } from 'vue';

import OfferCountdown from '@/components/OfferCountdown.vue';
import { setupI18n } from '@/shared/utils/i18n';

const initOfferCountdown = async () => {
  const mountSelector = '.js-offer-countdown';
  const element = document.querySelector<HTMLDivElement>(mountSelector);

  if (!element) return;

  const { endDate } = element.dataset;

  const i18n = await setupI18n(window.Shopify.locale);
  createApp(OfferCountdown, { endDate }).use(i18n).mount(mountSelector);
};

initOfferCountdown();
